// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Edit from "@hardwoods/XDL/Icons/Edit";
import { color } from "@hardwoods/XDL/Utilities";
import { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface AddressBlockStyle {
    titleText?: InjectableCss;
    wrapper?: InjectableCss;
    editLink?: LinkPresentationProps;
}

export const addressBlockStyle: AddressBlockStyle = {
    titleText: {
        css: css`
            font-size: 18px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 22px;
            padding-bottom: 12px;
            border-bottom: 1px solid ${color("common.border")};
            margin-bottom: 20px;
            display: block;
            width: 100%;
        `,
    },
    wrapper: {
        css: css`
            [data-test-selector*="companyName"] {
                font-weight: bold;
            }
        `,
    },
    editLink: {
        color: "secondary",
        icon: {
            iconProps: {
                src: Edit,
                color: "secondary",
                size: 14,
            },
        },
        typographyProps: {
            size: 15,
            css: css`
                letter-spacing: 0;
                line-height: 32px;
            `,
        },
    },
};
